import instance from '@/api/business'
import { Carrier } from '@/types/Carrier' 

export const fetchCarrier = async () => {
    const response = await instance.post<Carrier[]>('/carrier/cockpit/carrier')

    return response.data
}
 
